import React from 'react';

/**
 * Zet een formatiepositie om naar een stijl op de veldafbeelding.
 *
 * De coördinaten zijn hele procenten van de veldafbeelding: (0,0) is linksboven,
 * (100,100) rechtsonder, en de doelen liggen boven en onder. De overlay waarin deze
 * stijl landt is `absolute inset-0` over de afbeelding, dus procenten kunnen er
 * rechtstreeks in.
 *
 * Deze functie stond woordelijk in LineupFieldPreview én HockeyFieldBackground; de
 * sleep-editor werd de derde plek. Ze staat nu één keer, want gaan die uit elkaar
 * lopen, dan staan spelers op de spelerspagina ergens anders dan in de bewerker.
 */
export function veldPositieStijl(xPercent: number, yPercent: number): React.CSSProperties {
  return {
    position: 'absolute',
    left: `${xPercent}%`,
    top: `${yPercent}%`,
    transform: 'translate(-50%, -50%)',
  };
}

/** Terugval voor een positie zonder coördinaten, bijvoorbeeld een wisselspeler. */
export const VELD_MIDDEN_STIJL = veldPositieStijl(50, 50);
